package es.subastia.domain.usecase

import es.subastia.domain.model.UserDomainModel
import es.subastia.domain.repository.AuthRepository
import kotlinx.coroutines.flow.Flow

class ObserveAuthStateUseCase(private val repository: AuthRepository) {
    operator fun invoke(): Flow<UserDomainModel?> = repository.currentUser
}

class SignInWithEmailUseCase(private val repository: AuthRepository) {
    suspend operator fun invoke(email: String, pass: String): Result<Unit> =
        repository.signInWithEmail(email, pass)
}

class SignUpWithEmailUseCase(private val repository: AuthRepository) {
    suspend operator fun invoke(email: String, pass: String): Result<Unit> =
        repository.signUpWithEmail(email, pass)
}

class SignInWithGoogleUseCase(private val repository: AuthRepository) {
    suspend operator fun invoke(idToken: String): Result<Unit> =
        repository.signInWithGoogle(idToken)
}

class LogoutUseCase(private val repository: AuthRepository) {
    suspend operator fun invoke() = repository.signOut()
}
